import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//import { FlexModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTabsModule } from "@angular/material/tabs";

import { GlemtKodeordComponent } from "./glemt-kodeord/glemt-kodeord.component";
import { LoginContainerComponent } from "./login-container/login-container.component";
import { LoginEmailComponent } from "./login-email/login-email.component";
import { LoginForbrugernrComponent } from "./login-forbrugernr/login-forbrugernr.component";
import { LoginComponent } from "./login.component";

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        ReactiveFormsModule
    ],
    declarations: [LoginContainerComponent, LoginComponent, LoginEmailComponent, LoginForbrugernrComponent, GlemtKodeordComponent],
    providers: []
})
export class EForsyningFeaturesLoginModule {}
